
<p><strong>API:</strong> {{navizardAppVersion}} | <strong>UI:</strong> {{uiVersion }} <span *ngIf="liveTrackerVersion">
        | <strong>TRACKER:</strong> {{liveTrackerVersion}}</span></p>
<ng-container *ngIf="auth?.userAccessToken as accessToken">
    <p><strong>Session:</strong> {{accessToken.sessionName}}</p>
</ng-container>
